export default __webpack_public_path__ + "static/media/S-019.ae8f92c6.png";